<ambita-broker-letter-report class="ambita-broker-letter-report">
  <ambita-report-print-toolbar/>
  <report-header/>
  <ambita-loading-indicator show="{ loading }" loading-text="{ i18n.brokerLetterReport.loading }"/>

  <div class="ambita-broker-letter-report__error-wrapper" if="{ !loading && !data }">
    <span class="ambita-broker-letter-report__error">{ i18n.brokerLetterReport.error }</span>
  </div>

  <virtual if="{ !loading && data }">
    <div class="ambita-broker-letter-report__cadastre">
      <table class="ambita-broker-letter-report__cadastre-table">
        <thead>
          <tr class="ambita-broker-letter-report__cadastre-label-row">
            <th class="ambita-broker-letter-report__cadastre-label">{ i18n.brokerLetterReport.municipality }</th>
            <th class="ambita-broker-letter-report__cadastre-label"></th>
            <th class="ambita-broker-letter-report__cadastre-label">KNR</th>
            <th class="ambita-broker-letter-report__cadastre-label"></th>
            <th class="ambita-broker-letter-report__cadastre-label">GNR</th>
            <th class="ambita-broker-letter-report__cadastre-label"></th>
            <th class="ambita-broker-letter-report__cadastre-label">BNR</th>
            <th class="ambita-broker-letter-report__cadastre-label"></th>
            <th class="ambita-broker-letter-report__cadastre-label">FNR</th>
            <th class="ambita-broker-letter-report__cadastre-label"></th>
            <th class="ambita-broker-letter-report__cadastre-label">SNR</th>
          </tr>
        </thead>
        <tbody>
          <tr class="ambita-broker-letter-report__cadastre-value-row">
            <td class="ambita-broker-letter-report__cadastre-value">
              { data.municipality.municipalityName }
            </td>
            <td class="ambita-broker-letter-report__cadastre-value"></td>
            <td class="ambita-broker-letter-report__cadastre-value">
              { data.ident.municipalityNumber }
            </td>
            <td class="ambita-broker-letter-report__cadastre-value">-</td>
            <td class="ambita-broker-letter-report__cadastre-value">
              { data.ident.cadastralUnitNumber }
            </td>
            <td class="ambita-broker-letter-report__cadastre-value">/</td>
            <td class="ambita-broker-letter-report__cadastre-value">
              { data.ident.unitNumber }
            </td>
            <td class="ambita-broker-letter-report__cadastre-value">/</td>
            <td class="ambita-broker-letter-report__cadastre-value">
              { data.ident.leaseholdUnitNumber }
            </td>
            <td class="ambita-broker-letter-report__cadastre-value">/</td>
            <td class="ambita-broker-letter-report__cadastre-value">
              { data.ident.sectionNumber }
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="ambita-broker-letter-report__address">
      <h3 class="ambita-report-h3">{ data.addresses[0].shortStreetAddress }</h3>
      <span class="ambita-broker-letter-report__address-subtitle">
        { data.addresses[0].postalLocation }
      </span>
    </div>

    <div class="ambita-broker-letter-report__owners">
      <h4 class="ambita-report-h4">{ i18n.brokerLetterReport.owners }</h4>
      <div class="ambita-broker-letter-report__owners-table-wrapper">
        <table class="ambita-broker-letter-report__owners-table">
          <thead>
            <tr class="ambita-broker-letter-report__owners-label-row">
              <th class="ambita-broker-letter-report__owners-label">{ i18n.brokerLetterReport.name }</th>
              <th class="ambita-broker-letter-report__owners-label">{ i18n.brokerLetterReport.ownershipShare }</th>
              <th class="ambita-broker-letter-report__owners-label">
                { i18n.brokerLetterReport.nationalRegistryAddress }
              </th>
              <th class="ambita-broker-letter-report__owners-label">{ i18n.brokerLetterReport.role }</th>
            </tr>
          </thead>
          <tbody>
            <tr class="ambita-broker-letter-report__owners-value-row" if="{ data.mainCadastre }"
              each="{ owner in data.mainCadastre.owners }">
              <td class="ambita-broker-letter-report__owners-value">{ owner.name }</td>
              <td class="ambita-broker-letter-report__owners-value">{ owner.fraction }</td>
              <td class="ambita-broker-letter-report__owners-value">{ getAddressFromOwner(owner) }</td>
              <td class="ambita-broker-letter-report__owners-value">{ owner.cadastreLevel }</td>
            </tr>
            <tr class="ambita-broker-letter-report__owners-value-row" each="{ owner in data.owners }">
              <td class="ambita-broker-letter-report__owners-value">{ owner.name }</td>
              <td class="ambita-broker-letter-report__owners-value">{ owner.fraction }</td>
              <td class="ambita-broker-letter-report__owners-value">{ getAddressFromOwner(owner) }</td>
              <td class="ambita-broker-letter-report__owners-value">{ owner.cadastreLevel }</td>
            </tr>
            <tr class="ambita-broker-letter-report__owners-value-row" if="{ data.mainCadastre }"
              each="{ owner in data.mainCadastre.unregisteredOwnerships }">
              <td class="ambita-broker-letter-report__owners-value">{ owner.name }</td>
              <td class="ambita-broker-letter-report__owners-value">{ owner.fraction }</td>
              <td class="ambita-broker-letter-report__owners-value">{ getAddressFromOwner(owner) }</td>
              <td class="ambita-broker-letter-report__owners-value">{ owner.cadastreLevel }</td>
            </tr>
            <tr class="ambita-broker-letter-report__owners-value-row" each="{ owner in data.unregisteredOwnerships }">
              <td class="ambita-broker-letter-report__owners-value">{ owner.name }</td>
              <td class="ambita-broker-letter-report__owners-value">{ owner.fraction }</td>
              <td class="ambita-broker-letter-report__owners-value">{ getAddressFromOwner(owner) }</td>
              <td class="ambita-broker-letter-report__owners-value">{ owner.cadastreLevel }</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="ambita-broker-letter-report__various-information">
      <div class="ambita-broker-letter-report__cadastre-information">
        <h4 class="ambita-report-h4">{ i18n.brokerLetterReport.cadastreInformation }</h4>
        <div class="ambita-broker-letter-report__cadastre-information-block">
          <h6 class="ambita-report-h6">{ i18n.brokerLetterReport.residenceRequirements }</h6>
          <span class="ambita-broker-letter-report__cadastre-information-block-item
            ambita-broker-letter-report__warning">
            { data.zeroConcession ? data.zeroConcessionMessage : 'Nei' }
          </span>
        </div>
        <div class="ambita-broker-letter-report__cadastre-information-block">
          <h6 class="ambita-report-h6">{ i18n.brokerLetterReport.rental }</h6>
          <span class="ambita-broker-letter-report__cadastre-information-block-item">
            { data.separatelyOccupiedUnits && data.separatelyOccupiedUnits.length > 1 ? 'Ja' : 'Nei' }
          </span>
        </div>
      </div>
      <div class="ambita-broker-letter-report__area-information">
        <h4 class="ambita-report-h4">{ i18n.brokerLetterReport.area }</h4>
        <div class="ambita-broker-letter-report__area-information-block">
          <h6 class="ambita-report-h6">{ i18n.brokerLetterReport.commonArea }</h6>
          <span class="ambita-broker-letter-report__area-information-block-item">
            { data.ownershipsOwned && data.ownershipsOwned.length > 1 ? 'Ja' : 'Nei' }
          </span>
        </div>
      </div>
      <div class="ambita-broker-letter-report__area-information">
        <h4 class="ambita-report-h4">&nbsp;</h4>
        <div class="ambita-broker-letter-report__area-information-block">
          <h6 class="ambita-report-h6">{ i18n.brokerLetterReport.plotArea }</h6>
          <span class="ambita-broker-letter-report__area-information-block-item">
            { data.specifiedArea } m<sup>2</sup>
          </span>
        </div>
      </div>
    </div>

    <div class="ambita-broker-letter-report__buildings">
      <h4 class="ambita-report-h4">{ i18n.brokerLetterReport.buildings }</h4>
      <div class="ambita-broker-letter-report__buildings-table-wrapper">
        <table class="ambita-broker-letter-report__buildings-table">
          <thead>
            <tr class="ambita-broker-letter-report__buildings-label-row">
              <th class="ambita-broker-letter-report__buildings-label">{ i18n.brokerLetterReport.buildingType }</th>
              <th class="ambita-broker-letter-report__buildings-label">{ i18n.brokerLetterReport.drain }</th>
              <th class="ambita-broker-letter-report__buildings-label">{ i18n.brokerLetterReport.water }</th>
              <th class="ambita-broker-letter-report__buildings-label">{ i18n.brokerLetterReport.usableArea }</th>
              <th class="ambita-broker-letter-report__buildings-label">{ i18n.brokerLetterReport.totalArea }</th>
              <th class="ambita-broker-letter-report__buildings-label">{ i18n.brokerLetterReport.builtUpArea }</th>
            </tr>
          </thead>
          <tbody>
            <tr class="ambita-broker-letter-report__buildings-value-row" if="{ building.typeOfBuilding }"
              each="{ building in data.buildings }">
              <td class="ambita-broker-letter-report__buildings-value">{ building.typeOfBuilding.text }</td>
              <td class="ambita-broker-letter-report__buildings-value">{ building.dischargeType ? 'Ja' : 'Nei' }</td>
              <td class="ambita-broker-letter-report__buildings-value">{ building.waterSupplyType? 'Ja' : 'Nei' }</td>
              <td class="ambita-broker-letter-report__buildings-value">
                { building.totalFloorSpace + building.totalAreaOfPrimarySpace + building.areaOfSecondarySpace }
                m<sup>2</sup>
              </td>
              <td class="ambita-broker-letter-report__buildings-value">
                { building.totalArea + building.totalAreaHousing + building.totalAlternateArea } m<sup>2</sup>
              </td>
              <td class="ambita-broker-letter-report__buildings-value">{ building.builtUpArea } m<sup>2</sup></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="ambita-broker-letter-report__construction-cases">
      <h4 class="ambita-report-h4">{ i18n.brokerLetterReport.constructionCases }</h4>
      <div class="ambita-broker-letter-report__construction-cases-table-wrapper">
        <table class="ambita-broker-letter-report__construction-cases-table">
          <thead>
            <tr class="ambita-broker-letter-report__construction-cases-label-row">
              <th class="ambita-broker-letter-report__construction-cases-label">
                { i18n.brokerLetterReport.applicationDate }
              </th>
              <th class="ambita-broker-letter-report__construction-cases-label">
                { i18n.brokerLetterReport.applicationSubject }
              </th>
              <th class="ambita-broker-letter-report__construction-cases-label">
                { i18n.brokerLetterReport.completion }
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="ambita-broker-letter-report__construction-cases-value-row" each="{ building in data.buildings }">
              <td class="ambita-broker-letter-report__construction-cases-value">{ building.approvedDate.timestamp }</td>
              <td class="ambita-broker-letter-report__construction-cases-value">
                { building.typeOfBuilding && building.typeOfBuilding.text ||
                building.buildingChangeCode && building.buildingChangeCode.text }
              </td>
              <td class="ambita-broker-letter-report__construction-cases-value">
                { building.usedDate ? 'Ja' : 'Nei' }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ambita-broker-letter-report__construction-cases-notice-wrapper">
        <div class="ambita-broker-letter-report__construction-cases-notice">
          <span class="ambita-broker-letter-report__construction-cases-notice-text">
            Valgt kommune behandler ikke søknad om ferdigattest på tiltak søkt før 1998.
          </span>
        </div>
      </div>
    </div>

    <div class="ambita-broker-letter-report__attachments">
      <h4 class="ambita-report-h4">{ i18n.brokerLetterReport.attachments }</h4>
      <div class="ambita-broker-letter-report__attachments-block">
        <h6 class="ambita-report-h6">{ i18n.brokerLetterReport.cadastreLetter }</h6>
        <span class="ambita-broker-letter-report__attachments-block-item">Vedlagt</span>
      </div>
      <div class="ambita-broker-letter-report__attachments-block">
        <h6 class="ambita-report-h6">{ i18n.brokerLetterReport.measureLetter }</h6>
        <span class="ambita-broker-letter-report__attachments-block-item">Vedlagt</span>
      </div>
    </div>

    <div class="ambita-broker-letter-report__disclaimer-wrapper">
      <div class="ambita-broker-letter-report__disclaimer">
        <h5 class="ambita-report-h5">{ i18n.brokerLetterReport.disclaimerTitle }</h5>
        <span>{ i18n.brokerLetterReport.disclaimerText }</span>
      </div>
    </div>
  </virtual>

  <script>
    import '../common/reportHeader.tag';
    import '../common/loadingIndicator.tag';
    import '../reportPrintToolbar/reportPrintToolbar.tag';
    import './brokerLetterReport.scss';
    import './brokerLetterReportTranslations';
    import { init } from './brokerLetterReportController';

    init(this);
  </script>
</ambita-broker-letter-report>
